<template>
    <div :id="data.primary.presta_anchor" class="Presta_listItem">
      <h2 v-html="data.primary.presta_title"></h2>

      <div  class="Presta_category" >
        <template v-if="items.presa_type === 'Basique'" v-for="(items, i) in data.items" >
          <div v-if="items.presta_item.length > 0" :key="'item'+i" class="Presta_item">
              <div class="Presta_label">
                <prismic-rich-text v-if="items.presta_item" field="items.presta_item" :field="items.presta_item" />
              </div>
              <div class="Presta_infos">
                <span v-if="items.presta_duration" class="Presta_duration">{{items.presta_duration}}</span>
                <span v-if="items.presta_price" class="Presta_price">{{items.presta_price}}&nbsp;€</span>
              </div>
          </div>
          <div v-else>
              <br>
          </div>
        </template>
      </div>

      <div v-if="hasForfait" class="Presta_packageTitle">
        <h3>Forfaits</h3>
      </div>

      <div class="Presta_package" >
          <template v-for="(items, i) in data.items" v-if="items.presa_type !== 'Basique'" >
              <div v-if="items.presta_item.length > 0" :key="'packItem'+i" class="Presta_item">
                  <div class="Presta_label">
                      <prismic-rich-text v-if="items.presta_item" field="items.presta_item" :field="items.presta_item" />
                  </div>
                  <div class="Presta_infos">
                      <span v-if="items.presta_duration" class="Presta_duration">{{items.presta_duration}}</span>
                      <span v-if="items.presta_price" class="Presta_price">{{items.presta_price}}&nbsp;€</span>
                  </div>
              </div>
              <div v-else >
                  <br>
              </div>
          </template>
      </div>

      <p v-if="data.primary.presta_info" class="Presta_message">{{data.primary.presta_info}}</p>

      <img src="/assets/images/wave.svg"/>
    </div>
</template>

<script>

  export default {
    name: "PrestaCard",
    props: [ 'data' ],
    components: {

    },
    data() {
      return {
        isMobile: false,
        anchor: '',
      }
    },
      computed: {
        hasForfait()
        {
          var hasForfait = false
          this.data.items.forEach((item) => {
            if(item.presa_type !== 'Basique')
            {
              hasForfait = true
            }
          })
          return hasForfait
        }
      },
    methods: {
      onResize()
      {
        if(window.innerWidth < 768)
        {
          this.isMobile = true
        }else{
          this.isMobile = false
        }
      },
    },
    mounted()
    {
      this.$nextTick(() => {

        this.onResize()
        window.addEventListener('resize', this.onResize)

        var hashId = window.location.hash.substring(1)
        // console.log("hash", hashId)

        if (hashId.length > 0) {
            if (document.getElementById(hashId)){
                // console.log("anchor fils", anchor)
                this.$emit('anchor', document.getElementById(hashId))
            }
        }

      })
    },
    beforeDestroy()
    {
      window.removeEventListener('resize', this.onResize)
    }
  }
</script>

<style lang="stylus" scoped>
.Presta_listItem
  display inline-block
  width 90%
  color $dark-brown
  margin-bottom 40px
  text-align left

  @media $small
    margin-bottom 30px

  img
    margin-top 30px
    width 150px
    position relative
    left 50%
    transform translateX(-50%)

  h2
    color $light-brown

.Presta_category, .Presta_package
  display flex
  flex-direction column
  flex-wrap wrap
  align-items stretch
  justify-content space-between
  margin-top 20px

  @media $small
    margin-top 15px

.Presta_packageTitle

  h3
    margin-bottom 0
    margin-top 20px
    font-weight 900

.Presta_item
  display flex
  flex-direction row
  flex-wrap no-wrap
  justify-content space-between
  align-items flex-end
  color $dark-brown
  margin-bottom 8px

  @media $small
    margin-bottom 5px

.Presta_label
  padding-right 8px

.Presta_infos
  font-weight 900

.Presta_duration
  color $light-brown
  margin-right 20px

  @media $small
    margin-right 10px

.Presta_message
  font-style italic
  font-size 14px
  margin-top 20px
  line-height 20px

</style>


<style>
li::before {
    content: "+";
    display: inline-block;
    vertical-align: bottom;
    width: 15px;
    font-size: 22px;
}

ul {
    list-style-type: none;
}
</style>
